import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { CursorSpotlight } from "@/components/Magnetic";

// Scrolls to top on route change, or to a target section when navigated with state.
const ScrollManager = () => {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (id) {
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else if (!location.hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location]);
  return null;
};

export const Layout = () => {
  return (
    <div className="relative min-h-screen bg-nova-bg text-white">
      <SmoothScroll />
      <ScrollManager />
      <div className="noise-overlay" aria-hidden="true" />
      <CursorSpotlight />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-full focus:bg-white focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-nova-bg"
      >
        Skip to content
      </a>
      <Navbar />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
